export const DocumentCategory = Object.freeze({
  AllMedicalRecords: 'All medical records',
  LabResults: 'Lab Results',
  Imaging: 'Imaging',
  ProviderNotes: 'Provider notes',
  PreVisitIntake: 'Pre-Visit Intake',
  PatientSummary: 'Patient summary',
  SharedEducationalResources: 'Shared Educational Resources',
  Other: 'Other',
});

export const DocumentStatus = Object.freeze({
  Uploaded: 'Uploaded',
  Deleted: 'Deleted',
  FailedToUpload: 'Failed to upload',
});

export const DocumentCategoryOptions = Object.values(DocumentCategory).map((category) => ({
  value: category,
  label: category,
}));

export const DocumentUploadType = Object.freeze({
  PDF: 'pdf',
  LINK: 'link',
});

export const DocumentButtonLabel = Object.freeze({
  PDF: 'Upload Document',
  LINK: 'Upload Link',
});
